import React from 'react'
import { useAppSelector } from '../redux/hooks'
import imageLogo from '../images/image-logo.png'
import imageHero from '../images/image-hero.jpg'
import Button from './form/Button'
import { Link, useMatch, useParams } from 'react-router-dom'
import classnames from 'classnames'

const Hero = (): JSX.Element => {
  const prospect = useAppSelector((state) => state.app.prospect)
  const routeMatch = useMatch('/:prospectId')
  const { prospectId } = useParams<{ prospectId: string }>()

  return (
    <div
      className={classnames(
        'relative mx-auto overflow-hidden w-full max-w-[1200px] text-king-blue bg-no-repeat max-md:bg-[position:0_-280px]',
        {
          'min-h-[440px] py-[70px] max-md:min-h-[380px] max-md:py-10':
            routeMatch,
          'min-h-[310px] pt-[70px] max-md:min-h-0 max-md:pt-10': !routeMatch,
        }
      )}
      style={{
        backgroundImage: `url(${imageHero})`,
      }}
    >
      <div className="bg-gradient-to-b from-transparent to-white h-[120px] max-md:h-[50px] w-screen absolute bottom-0" />
      <div className="w-[70%] max-[900px]:w-full animate-[slideInFromLeft_1s_ease-out_0.2s_forwards] opacity-0">
        {/* King Header */}
        <div className="bg-king-red-900 h-[120px] max-md:h-[100px] w-full px-10 max-md:px-5 grid grid-cols-[min-content_80px_auto] max-md:grid-cols-[min-content_30px_auto] items-center text-white text-[30px] max-md:text-base font-light">
          <Link
            to="https://kingenergy.com"
            target="_blank"
            rel="noopener noreferrer"
            style={{ display: 'inherit' }}
          >
            <img
              src={imageLogo}
              alt=""
              className="!w-[200px] !min-w-[200px] max-md:!w-[130px] max-md:!min-w-[130px]"
            />
          </Link>
          {prospect?.property !== '' && (
            <>
              <span style={{ textAlign: 'center' }}>+</span>
              <span>{prospect?.property}</span>
            </>
          )}
        </div>

        {/* Welcome Section or Fade */}
        {routeMatch !== null ? (
          <div className="w-full inline-block p-10 bg-white/90 text-left relative font-normal">
            <h1 className="text-2xl font-normal m-0 mb-[10px]">
              Welcome, {prospect?.contact.firstName}!
            </h1>
            <p>
              King Energy is partnering with {prospect?.property} to install
              solar panels at your property.
            </p>
            <p>
              In order to serve you, please complete our onboarding process. To
              get started, click the "Get started now" button below.
            </p>
            <div>
              <Link
                to={`/${prospectId}/business`}
                className="inline-block mt-[10px] no-underline max-md:w-full"
              >
                <Button>Get started now</Button>
              </Link>
            </div>
          </div>
        ) : null}
      </div>
    </div>
  )
}

export default Hero
